// to ensure that the xarrow is unique, every state id is made unique by adding following extension to its id.

// NFA to DFA
export const ModifiedTableStateId = "mtt";
export const NullClosureStateId = "nc";
export const ResultantDfaStateId = "ntd";

// DFA Minimization
export const EquivalentStatesStateId = "est";
export const MinimizedDfaStateId = "md";

// Test a String
export const TestStringStateId = "ts";
